import { gql } from '@apollo/client'

export const UPDATE_TICKET_CONDITION = gql`
mutation updateTicketCondition($input: UpdateTicketConditionInput!) {
  updateTicketCondition(input: $input) {
    errors
    ticketUuid
    ticketConditionUuid
    ticketCondition {
      id
      lightingConditions {
        id
        name
        oriId
      }
      roadConditions {
        id
        name
        oriId
      }
      trafficConditions {
        id
        name
        oriId
      }
      weatherConditions {
        id
        name
        oriId
      }
    }
  }
}
`